import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  // static targets = ["toggleable"];

  connect() {
    console.log("Drawer Filters controller connected");
  }

  closeFilters() {
    document.getElementById("drawer_filters").classList.add("hidden");
    document.body.classList.remove("overflow-x-hidden", "overflow-y-hidden");
  }

  removeFilters() {
    document.getElementById("filter_manual").classList.remove("border", "border-gray-500");
    document.getElementById("filter_auto").classList.remove("border", "border-gray-500");
    document.getElementById("remove_filters").classList.add("border", "border-gray-500");
    let cars = document.querySelectorAll(".car");
    cars.forEach((car) => {
      car.classList.remove("hidden");
    });
  }
  manualFilter() {
    document.getElementById("filter_manual").classList.add("border", "border-gray-500");
    document.getElementById("filter_auto").classList.remove("border", "border-gray-500");
    document.getElementById("remove_filters").classList.remove("border", "border-gray-500");
    document.querySelectorAll(".automatic").forEach((car) => {
      car.classList.add("hidden");
    });
    document.querySelectorAll(".manual").forEach((car) => {
      car.classList.remove("hidden");
    });
  }
  automaticFilter() {
    document.getElementById("filter_auto").classList.add("border", "border-gray-500");
    document.getElementById("filter_manual").classList.remove("border", "border-gray-500");
    document.getElementById("remove_filters").classList.remove("border", "border-gray-500");
    document.querySelectorAll(".manual").forEach((car) => {
      car.classList.add("hidden");
    });
    document.querySelectorAll(".automatic").forEach((car) => {
      car.classList.remove("hidden");
    });
  }
}
